import { render } from "./PatientList.vue?vue&type=template&id=0e369379&scoped=true&ts=true"
import script from "./PatientList.vue?vue&type=script&lang=ts"
export * from "./PatientList.vue?vue&type=script&lang=ts"

import "./PatientList.vue?vue&type=style&index=0&id=0e369379&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e369379"]])

export default __exports__